import yup from 'src/libs/yup';

const ReasonFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  status: yup.array().of(yup.string()).nullable().label('Status'),
  type: yup.string().nullable().label('Tipo'),
});

export default ReasonFilterSchema;
